const postCloneChecklist = {
  toastr: 'Checklist Clonada',
  toastr1: 'El Modelo fue actualizado con éxito',
  toastrError: 'Nombre ya registrado',
  toastrError1: 'Ingrese otro nombre',
  toastr1Error: 'Checklist vacía',
  toastr1Error1: 'Ingrese preguntas en la checklist antes de clonarla'
};

export default postCloneChecklist;
